import {User} from "@/models/user.model";
export class UserSearchResultModel {
    public usersFound: User[]=[];
    public totalNumberOfUsersFound:number= 0;
    public numberOfUsersToDisplay:number= 4;
    public page:number=1;
    public startSlide:number=0;
}